const AcsLoading = () => {
  return (
    <div className="p-6">
      <p className="text-gray-500 font-semibold text-xl">
        Welcome to your ACS Dashboard
      </p>
      <p className="text-gray-500">Select a candidate to view details</p>
    </div>
  );
};

export default AcsLoading;
